import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import { useRouter, useRoute } from 'vue-router'
import { getCurrentInstance, reactive, onActivated, ref } from 'vue'
import Pagination from '@/components/Pagination.vue'
import { getFiltersListApi, getProgressListApi, updateProgressUrgencyApi, cancelProgressApi } from '../../apis/brand-expand'
import Keys from '@/constant/key'
import { useStore } from '@/store'
import { joinParams } from '@/utils/index'
import { ProgressStatus, RoleList } from '@/enums/brand'


export default /*@__PURE__*/_defineComponent({
  __name: 'Progress',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const route = useRoute()
const store = useStore()

const { role } = route.meta as any

const filters = reactive({
    type: role, // 列表类型
    brand_name: null, // 品牌名称
    product_status: '', // 商品上架状态：1-无，2-未达到最低量（8个），3-正常
    follow_status: '', // 沟通进度：0-待处理，1-进行中，2-已完成，3-终止
    brand_status: '',
    follow_name: '', // 操作人
    interflow_name: '', // 沟通状态
    page: 1,  // 当前页码
    page_size: 10, // 每页显示条数
})
const filterBrandList = ref<any[]>([]) // 品牌筛选项列表
const filtersOperatorList = ref<any[]>([]) // 操作人筛选项列表
const getFiltersList = async () => {
    const { code, data, msg } = await getFiltersListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    filterBrandList.value = data.brand_info
    filtersOperatorList.value = data.admin_names
}
getFiltersList()


const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, msg } = await getProgressListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}

const rowClassName = ({ row }) => {
    if (row.is_urgent) {
        return 'danger-row'
    }
}

// 跳转至编辑页
const toEdit = (row, t) => {
    router.push(`/brand-expand/progress-detail?id=${row.id}&t=${t}&r=${filters.type}`)
}

// 加急
const onDanger = async (id:number) => {
    const { code, data, msg } = await updateProgressUrgencyApi(id) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    proxy.$message({ type: 'success', message: '操作成功' })
    getList()
}

// 强制终止
const onCancel = (id:number) => {
    proxy.$confirm('确定要强制终止？', '提示', {
        type: 'warning',
    }).then(async () => {
        const { code, data, msg } = await cancelProgressApi(id) as any
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        proxy.$message({ type: 'success', message: '操作成功' })
        getList()
    }).catch(() => {
        console.log('取消删除')
    })
}

const onExport = () => {
    window.open(`${Keys.baseUrl}/brand/followupList?${joinParams({...filters, user_id: store.state.user.userInfo.id })}&is_export=1`)
}
const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onActivated(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select_v2, {
        class: "filter-item",
        modelValue: filters.brand_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.brand_name) = $event)),
        filterable: "",
        options: filterBrandList.value,
        props: {
                    value: 'brand_name',
                    label: 'brand_name',
                },
        placeholder: "请选择品牌名称",
        clearable: ""
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.brand_status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.brand_status) = $event)),
        placeholder: "请选择品牌状态",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "上架",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "下架",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "待上线",
            value: 3
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.follow_status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.follow_status) = $event)),
        placeholder: "请选择沟通进度",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待处理",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "进行中",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "已完成",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "终止",
            value: 3
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.product_status,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.product_status) = $event)),
        placeholder: "请选择上架状态",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "无",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "正常",
            value: 3
          }),
          _createVNode(_component_el_option, {
            label: "未达最低量（8个）",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.interflow_name,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.interflow_name) = $event)),
        placeholder: "请选择沟通状态",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "沟通资料中",
            value: "沟通资料中"
          }),
          _createVNode(_component_el_option, {
            label: "整理资料中",
            value: "整理资料中"
          }),
          _createVNode(_component_el_option, {
            label: "作图中",
            value: "作图中"
          }),
          _createVNode(_component_el_option, {
            label: "待上传",
            value: "待上传"
          }),
          _createVNode(_component_el_option, {
            label: "沟通多次无果",
            value: "沟通多次无果"
          }),
          _createVNode(_component_el_option, {
            label: "已完成",
            value: "已完成"
          }),
          _createVNode(_component_el_option, {
            label: "终止",
            value: "终止"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select_v2, {
        class: "filter-item",
        modelValue: filters.follow_name,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.follow_name) = $event)),
        filterable: "",
        clearable: "",
        options: filtersOperatorList.value,
        props: {
                    value: 'username',
                    label: 'username'
                },
        placeholder: "请选择操作人"
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: "",
      "row-class-name": rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID"
        }),
        _createVNode(_component_el_table_column, { label: "品牌" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.brand_name) + " ", 1),
            (scope.row.is_urgent)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(['danger-badge', ['已完成', '终止'].includes(scope.row.follow_status_name) ? 'done' : ''])
                }, "急", 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_status",
          label: "品牌上架状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cat_name",
          label: "类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "record_count",
          label: "沟通次数"
        }),
        _createVNode(_component_el_table_column, {
          prop: "product_count",
          label: "上架数量"
        }),
        _createVNode(_component_el_table_column, {
          prop: "product_status",
          label: "上架状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "follow_status_name",
          label: "沟通进度"
        }),
        _createVNode(_component_el_table_column, {
          prop: "interflow_name",
          label: "沟通状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: "创建开通时间",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "up_time",
          label: "沟通时间(最新)",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "follow_name",
          label: "操作人(最新)",
          width: "95"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "175",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                class: "mb10",
                type: "primary",
                size: "small",
                disabled: scope.row.follow_status == 2 || scope.row.follow_status == 3 || (_unref(RoleList)[_unref(role)] === '商务' && _unref(ProgressStatus)[scope.row.status] !== '商务跟进中')  || (_unref(RoleList)[_unref(role)] === '上架负责人' && _unref(ProgressStatus)[scope.row.status] !== '上架负责人跟进中') ,
                onClick: ($event: any) => (toEdit(scope.row, 'edit'))
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("跟进并记录")
                ])),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              (_unref(RoleList)[_unref(role)] !== '上架负责人')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "mb10",
                    type: "danger",
                    size: "small",
                    disabled: scope.row.follow_status_name !== '待处理' && scope.row.follow_status_name !== '处理中' || Boolean(scope.row.is_urgent),
                    onClick: ($event: any) => (onDanger(scope.row.id))
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("加急")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              (_unref(RoleList)[_unref(role)] !== '上架负责人')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "danger",
                    size: "small",
                    disabled: scope.row.follow_status_name === '终止',
                    onClick: ($event: any) => (onCancel(scope.row.id))
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("强制终止")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toEdit(scope.row, 'view'))
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"])
  ]))
}
}

})